export default __webpack_public_path__ + "static/media/wheat.6f44f39d.svg";